<template lang="html">
  <nav
    class="icon-bar"
  >
    <ul class="icon-bar__list">
      <li
        v-for="(item) in items"
        :key="item.name"
        class="icon-bar__item"
      >
        <nuxt-link
          v-if="item.resource.targetPage && item.resource.targetPage.url"
          :to="item.resource.targetPage.url"
          class="icon-bar__link"
        >
          <span class="icon-bar__title">
            {{ item.resource.columns.title }}
          </span>
          <component
            :is="item.icon"
            class="icon-bar__icon"
          />
        </nuxt-link>
        <a
          v-else-if="item.resource.columns.targetUrl"
          :href="item.resource.columns.targetUrl"
          target="_blank"
          class="icon-bar__link"
        >
          <span class="icon-bar__title">
            {{ item.resource.columns.title }}
          </span>
          <component
            :is="item.icon"
            class="icon-bar__icon"
          />
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import SubNavigation from 'beisheim/components/elements/sub-navigation'

export default {
  components: {
    SubNavigation
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      activeItem: null
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/font';

  .icon-bar {
    display: flex;
    align-items: center;
  }

  .icon-bar__list {
    display: flex;
  }

  .icon-bar__item {
    position: relative;
  }

  .icon-bar__link {
    display: block;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 100%;
      background-color: gray(4);
      z-index: -1;
      opacity: 0;
      transform: scaleX(1.2) scaleY(1.2);
      transition: transform 250ms ease-in-out, opacity 50ms ease-out;
    }

    &:hover::before {
      transform: scaleX(1) scaleY(1);
      opacity: 1;
    }
  }

  .icon-bar__icon {
    display: block;
    width: 40px;
  }

  .icon-bar__title {
    @include font(-1);
    opacity: 0;
    background-color: #F2F2F2;
    padding: 5px;
    border-radius: 200px;
    padding-left: 15px;
    padding-right: 15px;
    transition: transform 0.2s ease-in-out;
    position: absolute;
    top:-30px;
    left: 50%;
    transform: translateX(-50%);

    &:after {
      content: "";
      display: block;
      position: absolute;
      font-size: 2px;
      left: 50%;
      transform: translateX(-50%);
      bottom: -6px;
      border-top: 6px solid #F2F2F2;
      border-right: 12px solid transparent;
      border-left: 12px solid transparent;
      border-bottom: none;
    }
  }

  .icon-bar__item:hover {
    .icon-bar__title {
      opacity: 1;
      transform: translateY(-50%) translateX(-50%);
    }
  }
</style>
